import React from 'react';
export const Header = () => {
  return <header className="w-full bg-blue-900 text-white py-4" data-id="element-133">
      <div className="container mx-auto px-4 flex justify-between items-center" data-id="element-134">
        <a href="https://offer.getveloura.co.uk/" target="_blank" rel="noopener noreferrer" className="hover:opacity-90 transition-opacity" data-id="element-135">
          <div className="text-xl font-semibold" style={{
          fontFamily: "'DM Sans', sans-serif"
        }} data-id="element-136">
            Veloura
          </div>
        </a>
        <div className="text-sm" data-id="element-137">Advertorial</div>
      </div>
    </header>;
};